var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgDrop(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 16 24"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.15 12.75l-.69-1.33L8.88.55a1 1 0 00-1.76 0L1.54 11.42l-.69 1.33A7.79 7.79 0 008 24a7.79 7.79 0 007.15-11.25",
    fill: "#02bd9c",
    fillRule: "evenodd",
    className: "svgdrop"
  })));
}

SvgDrop.displayName = 'Drop';
export default SvgDrop;